import { render, staticRenderFns } from "./rule-form-tab4.vue?vue&type=template&id=9bf94f7e&scoped=true&"
import script from "./rule-form-tab4.vue?vue&type=script&lang=ts&"
export * from "./rule-form-tab4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf94f7e",
  null
  
)

export default component.exports